import styled from "styled-components";
import blogbackground from "../assets/2022/photos/blog.JPG";

export default styled.div`

  .layout{
    padding: 2.5em 1em;
  }


  .withBackground {

   position: relative;
   background: url(${blogbackground});
   background-repeat: no-repeat;
   background-size: cover;
   background-position: 0% 25%;

   @media(min-width: 2000px){
     background-position: 5% 25%;
   }

   height: 400px;
   display: flex;
   flex-direction: column;
   align-content: flex-start;
   align-items: flex-start;
   justify-content: center;
   padding: 0 1.75em;

   &::before {
     content: "";
     position: absolute;
     background: rgba(0, 0, 0, 0.25);
     top: 0;
     left: 0;
     bottom: 0;
     right: 0;
     height: 100%;
     width: 100%;
   }

   h3{
     margin: 0;
     font-weight: 1000;
     font-size: 24px;
     text-transform: uppercase;
     text-align: left;
     font-style: italic;
   }

   p{

     font-weight: 600;
     font-size: 3em;
     @media(max-width: 1024px){
     font-size: 2em;
     }
   }

   h3,p{
     color: white;
     ;
     text-align: left;
   }


  }
  #blog {
    margin: 1em 0;

    h2 {
      margin: 4em 0 2em;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      font-size: 29px;
      color: #222829;
    }
    .post-card {

      margin: 1em 0;

      .inner {
        background: #ffffff;
        box-shadow: 0px 4px 25px rgba(61, 72, 81, 0.05);
        border-radius: 4px;
        min-height: 530px;

        .inner-inner {
          padding: 1.25em;
          height: 355px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
        }

      }

      h3 {
        line-height: 33px;
        font-size: 20px;
        margin: 0.5em 0;
        color: #009444;
        width: 100%;
      }

      p {

        line-height: 26px;
        font-size: 15px;
        font-weight: 300;
        color: #3d4851;
        align-self: flex-start;
        height: 180px;
        overflow: hidden;
        width: 100%;

      }

      img {
        width: 100%;
        height: 230px;
        object-fit: cover;
        object-position: top;
      }

      a {
        display: block;
        font-style: normal;
        font-weight: 600;
        line-height: 27px;
        font-size: 18px;
        text-decoration: none;
        color: #acbb15;
        position: relative;
      }
    }
  }



  .top, .mid, .bottom {

    a{
      position: relative;
      height: 300px;
      display: inline-block;
      text-decoration: none;
      font-size: 18px;
      width: 100%;
      margin-bottom: 1em;
    }

    .flex-wrap{
      padding: 1.5em;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      height: 100%;
      width: 100%;

      h3{
        margin: 0 0 5px;
        font-size: 24px;
        padding-right: 0;
        padding-left: 0;
        font-family: Poppins;
        font-weight: 500;
        color: #fff;
        text-align: left;
      }

    }

    button {
      display: inline-block;
      outline: none;
      border: 0;
      padding: 1em 0;
      font-size: 18px;
      background: none;
      border-bottom: 2px solid white;
      border-radius: 0;
    }

    img {

      width: 100%;
      height: 100%;
      background: lightgray;
      object-fit: cover;
      object-position: top;
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 0;

      &::before{
        content: "";
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: 0%;
        right: 0%;
        height: 100%;
        width: 100%;
        z-index: -1;
        background: rgba(0,0,0,0.5);
      }

    }

    h3,p,a, button {

      z-index: 1;
      position: relative;
      color: white;
    }

  }

  @media(max-width: 768px){

    .layout{
      padding: 1.5em 0em;
    }

    .header{
        padding: 0;
        height: 250px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    p, li, span{
      font-size: 14.5px !important;
      line-height: 30px !important;
    }

    .header h3, .header p{
      margin-left: 1em !important;
    }

    .header h3{
      font-size: 21px;
    }

    .header p{
      font-size: 1.25em !important;
        line-height: 1.7em !important;
        letter-spacing: 0.75px;
        font-weight: 600;
    }

  }


  @media(min-width: 768px){

    .top, .mid, .bottom {
      a{
        margin-bottom: 2em;
      }
    }

  }

  .imageNeedingOverlay{
     position: absolute;
     height: 100%;
     z-index: 1;
     background: rgba(0,0,0,0.2);
     top: 0;
     left: 0;
     right: 0;
     bottom: 0;
     justify-content: center;
     margin: auto;
     align-items: center;
     align-self: center;
  }

`;



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/blog.style.js